import { useWalletConnect } from '@btc-vision/walletconnect';

function formatAddress(addr: string): string {
    if (addr.length <= 14) return addr;
    return `${addr.slice(0, 8)}...${addr.slice(-6)}`;
}

interface NavbarProps {
    readonly onHistoryClick?: () => void;
    readonly onMyCampaignsClick?: () => void;
}

export function Navbar({ onHistoryClick, onMyCampaignsClick }: NavbarProps) {
    const { openConnectModal, disconnect, walletAddress, connecting, walletBalance } =
        useWalletConnect();

    const balanceSats = walletBalance?.total ?? 0;
    const balanceBTC = (Number(balanceSats) / 1e8).toFixed(6);

    return (
        <nav className="navbar">
            <div className="container navbar__inner">
                <div className="navbar__logo">
                    <span className="navbar__logo-icon">
                        <svg width="22" height="22" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            {/* BTC symbol */}
                            <path
                                d="M21.8 14.2c.9-1.2.7-3.2-.4-4.2-.7-.7-1.7-1-2.7-1.1V6.5h-1.8v2.3h-1.4V6.5h-1.8v2.4H11v1.8h1c.5 0 .8.3.8.8v7.2c0 .4-.3.7-.7.7H11l-.4 2h3v2.4h1.8v-2.4h1.4v2.4h1.8v-2.5c2.2-.2 3.7-1.1 4-3.1.2-1.6-.6-2.9-1.8-3.4zM15.5 11h1.6c1 0 1.8.5 1.8 1.5s-.8 1.5-1.8 1.5h-1.6V11zm2 9h-2v-3.2h2c1.2 0 2 .6 2 1.6s-.8 1.6-2 1.6z"
                                fill="currentColor"
                            />
                            {/* Circle ring */}
                            <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="2.2" fill="none" />
                        </svg>
                    </span>
                    <span>
                        Bit<span className="text-accent">Fund</span>
                    </span>
                </div>

                <div className="navbar__links">
                    <a href="#campaigns" className="navbar__link">
                        Campaigns
                    </a>
                    <a href="#how-it-works" className="navbar__link">
                        How It Works
                    </a>
                    <a href="#stats" className="navbar__link">
                        Stats
                    </a>
                </div>

                {walletAddress ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <span className="network-badge">
                            <span className="network-badge__dot" />
                            Testnet
                        </span>
                        <span
                            style={{
                                fontFamily: 'var(--font-mono)',
                                fontSize: 'var(--font-size-sm)',
                                color: 'var(--text-accent)',
                            }}
                        >
                            {balanceBTC} BTC
                        </span>
                        {onMyCampaignsClick && (
                            <button
                                className="navbar__history-btn"
                                onClick={onMyCampaignsClick}
                                title="My Campaigns"
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="3" width="7" height="7" />
                                    <rect x="14" y="3" width="7" height="7" />
                                    <rect x="3" y="14" width="7" height="7" />
                                    <rect x="14" y="14" width="7" height="7" />
                                </svg>
                            </button>
                        )}
                        {onHistoryClick && (
                            <button
                                className="navbar__history-btn"
                                onClick={onHistoryClick}
                                title="Donation History"
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="12" cy="12" r="10" />
                                    <polyline points="12 6 12 12 16 14" />
                                </svg>
                            </button>
                        )}
                        <button className="btn btn--wallet" onClick={disconnect}>
                            {formatAddress(walletAddress)}
                        </button>
                    </div>
                ) : (
                    <button
                        className="btn btn--primary"
                        onClick={openConnectModal}
                        disabled={connecting}
                    >
                        {connecting ? 'Connecting...' : 'Connect Wallet'}
                    </button>
                )}
            </div>
        </nav>
    );
}
